import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useBilling } from '../../../context/BillingContext';
import styles from './FeatureGate.module.css';

interface Props {
  feature: string;
  children: React.ReactNode;
  fallbackTitle?: string;
}

const UPGRADE_MAP: Record<string, string> = {
  api_access: 'growth',
  advanced_ai: 'growth',
  team_collaboration: 'growth',
  sso: 'growth',
  predictive_analytics: 'growth',
  dedicated_support: 'growth',
  export_reporting: 'professional',
};

const FeatureGate: React.FC<Props> = ({ feature, children, fallbackTitle }) => {
  const { canUse, upgradeTierFor, loading } = useBilling();
  const navigate = useNavigate();

  if (loading) return null;
  if (canUse(feature)) return <>{children}</>;

  const upgradeTo = upgradeTierFor(feature) ?? UPGRADE_MAP[feature] ?? 'professional';

  return (
    <div className={styles.locked}>
      <span className={styles.lockIcon}><Lock size={20} aria-hidden /></span>
      <p className={styles.title}>{fallbackTitle ?? `${feature.replace(/_/g, ' ')} requires an upgrade`}</p>
      <button
        className={styles.upgradeBtn}
        onClick={() => navigate(`/billing/checkout?plan=${upgradeTo}`)}
      >
        Upgrade to {upgradeTo.charAt(0).toUpperCase() + upgradeTo.slice(1)}
      </button>
    </div>
  );
};

export default FeatureGate;
